export const HOME = '*';
export const LOGIN = '/login';
export const USER_PROFILE = '/user-profile/:userId';
